import React from "react";
import styled from "styled-components";
import {
    STATUS_DECLINED_BG,
    STATUS_DECLINED_COLOR,
    STATUS_DEFAULT_BG,
    STATUS_DEFAULT_COLOR,
    STATUS_PENDING_BG,
    STATUS_PENDING_COLOR,
    STATUS_SOLVED_BG,
    STATUS_SOLVED_COLOR,
} from "../constants/style/colors";

export const TagStyle = styled.div`
    border-radius: 10px;
    height: 20px;
    width: auto;
    padding: 5px 10px;
    display: flex;
    align-items: center;
    color: ${(props) => props.color};
    background-color: ${(props) => props.background};
    text-transform: capitalize;
`;
function Tags({ label, Class }) {
    return (
        <TagStyle
            className={Class}
            color={
                label === "resolved"
                    ? STATUS_SOLVED_COLOR
                    : label === "declined"
                    ? STATUS_DECLINED_COLOR
                    : label === "pending"
                    ? STATUS_PENDING_COLOR
                    : STATUS_DEFAULT_COLOR
            }
            background={
                label === "resolved"
                    ? STATUS_SOLVED_BG
                    : label === "declined"
                    ? STATUS_DECLINED_BG
                    : label === "pending"
                    ? STATUS_PENDING_BG
                    : STATUS_DEFAULT_BG
            }
        >
            {label}
        </TagStyle>
    );
}

export default Tags;
